(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('ValidationMessageHelper', ValidationMessageHelper)

    /** @ngInject */
    function ValidationMessageHelper() {
        const ValidationMessageHelper = {
            getMessage
        }

        return ValidationMessageHelper;

        function getMessage(messageType) {
            const messages = {
                required: 'Campo Obrigatório',
                email: 'Forneça um e-mail válido',
                date: 'Forneça uma data válida',
                number: 'Forneça um número válido',
                url: 'Forneça uma url válida',
                cep: 'Forneça um CEP válido',
                cpf: 'Forneça um CPF válido',
                cnpj: 'Forneça um CNPJ válido',
                phone: 'Forneça um telefone válido',
                ddd: 'Forneça um DDD válido'
            }

            return messages[messageType];
        }
    }
}());